import { STATUS } from '@features/General'
import { createSlice } from '@reduxjs/toolkit'

export interface IListState {
    status: string
    data: {
        [key: string]: string[]
    }
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: {
        ITPType: [],
        companySize: [],
        locations: [],
        type: []
    },
    errors: null
}

const itpStaticEnumsSlice = createSlice({
    name: 'hub/companies/itp-static-enums',
    initialState,
    reducers: {
        onRequest(state, action) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const itpStaticEnumsActions = itpStaticEnumsSlice.actions
export default itpStaticEnumsSlice.reducer
